import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * basicinfo set API
 * @author Ju
 */
export default {
  /**
   * basicinfoId에 대한 basicinfo set 목록을 반환한다.
   * @author Ju
   * @param  {string} basicinfoId [basicinfoId]
   * @return {array}             basicinfo set 배열
   */
  getList(basicinfoId) {
    return axios.get(`${baseUrl}/common/basicinfo/get-basicinfo-set-list.do`, { params: { basicinfoId } });
  },
  /**
   * basicinfo_set의 정보를 수정한다.
   * @author jeee12
   * @param  {[type]} params 수정할 basicinfo_set 배열
   * @return {[type]}        [description]
   */
  updateList(params) {
    return axios.post(`${baseUrl}/common/basicinfo/update-basicinfo-set-list.do`, params);
  },
  /**
   * basicinfo_set 항목을 조회한다.
   *
   * @author gimang
   * @param {object} params basicinfoId, basicinfoSubId
   * @return {object}
   */
  getBasicinfoSet(params) {
    return axios.get(`${baseUrl}/common/basicinfo/get-basicinfo-set.do`, { params });
  },
};



// WEBPACK FOOTER //
// ./src/api/model/basicinfo-set.js